import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { formatErr } from "@/lib/api";
import { ArrowRight } from "@phosphor-icons/react";
import { toast } from "sonner";
import RankTrustLogo from "@/components/RankTrustLogo";
import SEOHead from "@/lib/seo/SEOHead";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success("Welcome back");
      if (u.role === "agency") nav("/app/agency");
      else nav("/app");
    } catch (err) {
      toast.error(formatErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 md:grid-cols-2">
      <SEOHead path="/login" />
      <div className="hidden md:flex flex-col justify-between p-12 bg-zinc-950 text-white grid-bg">
        <div data-testid="login-brand"><RankTrustLogo height={36} asLink tagline taglineColor="#9CA3AF" /></div>
        <div>
          <h2 className="font-display text-4xl font-black tracking-tighter">
            Welcome back. Let's get you back to the<br /><span className="text-[#FACC15]">Top 3</span>.
          </h2>
          <p className="mt-4 text-zinc-400 max-w-md">Your ranking intelligence has been watching while you were away.</p>
        </div>
        <div className="font-mono text-xs text-zinc-500">RANKTRUST · AI Growth Intelligence Platform</div>
      </div>
      <div className="flex items-center justify-center p-8 md:p-16">
        <form onSubmit={onSubmit} className="w-full max-w-md space-y-5" data-testid="login-form">
          <div>
            <div className="label-tiny mb-2">Welcome back</div>
            <h1 className="font-display text-3xl font-black tracking-tight">Log in</h1>
          </div>
          <div className="space-y-2">
            <label className="label-tiny block">Email</label>
            <input className="input-field" type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} data-testid="login-email" />
          </div>
          <div className="space-y-2">
            <div className="flex items-center justify-between gap-3">
              <label className="label-tiny block">Password</label>
              <Link to="/forgot-password" className="text-sm text-[#002FA7] font-semibold hover:underline">Forgot password?</Link>
            </div>
            <input className="input-field" type="password" required value={password} onChange={(e)=>setPassword(e.target.value)} data-testid="login-password" />
          </div>
          <button type="submit" className="btn-primary w-full justify-center" disabled={busy} data-testid="login-submit">
            {busy ? <span className="spinner"></span> : <>Log in <ArrowRight size={14} weight="bold" /></>}
          </button>
          <div className="text-sm text-zinc-600">
            New here? <Link to="/register" className="text-[#002FA7] font-semibold" data-testid="login-to-register">Create an account</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
